export default __webpack_public_path__ + "static/media/lyor.152abc1a.webp";